<script>


import Popper from "vue3-popper";
import { useToast } from "vue-toastification";

import tinyMCEeditor from '@/ui/tinyMCEgeneral'

 //components
 import LoadingScreen from '@/components/General/LoadingScreen'
 import LoadingButton from '@/components/General/LoadingButton'


//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

//data
import { getStateOptions } from '@/services/serviceCommon';
import { getAccessRightsOptions } from '@/services/serviceAccessRight';
import { getCampaign, unlockCampaign, saveCampaign, createCampaign, loadTemplateData } from '@/services/mailing/serviceCampaign';


export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'CampaignEdit',
	mixins: [ MixinGeneralFunct ],
	components: {
		tinyMCEeditor
		,Popper
		,LoadingScreen
		,LoadingButton
	},
	props: {'campaignId': String, 'auth':Object, 'secData':Object, 'modalObject': Object, 'modalId': String},
	emits: ["campaignId","changeRecord"],
	data() {
	
		return {
			metaData: [],
			
			isLoading:true,
			isSending:false,
			
			isNewRecord:true,

			optionsAccessLevels: [],
			optionsTypes:[],
			optionsTemplates:[],
			optionsStates:[],
			optionsLanguages:[],
			
			initObj: {
				
				relative_urls: false
				,convert_urls: false
				,remove_script_host:false
				,height:450
				,entity_encoding : "raw" 
				,language:'sk'
				,extended_valid_elements: 'i[class]'
				,iconfonts_selector: '.fa, .fab, .fal, .far, .fas, .glyphicon'
			},
			
						
			//form
			data:[],
			template:[],

			//tabs
			tab1:'',
			tab2:'',
			tab3:'',
			tab4:'',
			
		}
	},
	
	mounted:function(){
		this.tab1 = `tab${this.getRandomInt(99999999999)}`;
		this.tab2 = `tab${this.getRandomInt(99999999999)}`;
		this.tab3 = `tab${this.getRandomInt(99999999999)}`;
		this.tab4 = `tab${this.getRandomInt(99999999999)}`;
	},
	
	methods: {
		// load data form
		loadDefaultValues:function(){

			this.isLoading=true
			getCampaign({campaignId:this.campaignId}).then(response => {
				if(!response.statusText){
					console.log(response)
					this.isLoading=false
					this.metaData = response.metaData;
					this.data = response.data;
					this.optionsTypes = response.optionsTypes;
					this.optionsTemplates = response.optionsTemplates;
					this.template = response.template;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getAccessRightsOptions().then(response => {
				if(!response.statusText){
					this.optionsAccessLevels = response.optionsAccessLevels;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});

			getStateOptions().then(response => {
				if(!response.statusText){
					this.optionsStates = response.optionsStates;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
			
		},

		// load template data
		onLoadTemplateData:function(){
			
			loadTemplateData(this.data.templateId).then(response => {
				if(!response.statusText){
					console.log(response)
					this.template = response.template;
				}else{
					this.toast.error(`${response.statusText} ${response.status}`);
				}
			});
			
		},
		
		checkSave:function(){
								
			if(!this.data.name){this.data.nameError = true; }else{this.data.nameError = false;}
			if(!this.data.access){this.data.accessError = true; }else{this.data.accessError = false;}
			if(!this.data.typeId){this.data.typeError = true; }else{this.data.typeError = false;}
			if(!this.data.templateId && this.data.typeId == 1){this.data.templateError = true; }else{this.data.templateError = false;}
			
			if(this.data.name && this.data.access && this.data.typeId && !this.data.templateError){
				return true;
			}else{
				return false;
			}
		},	
		

		onSave:function(){
							
			if(this.checkSave()){
				if(this.campaignId!='null'){		
					this.isSending=true
					saveCampaign({data:this.data}).then(response => {
						if(!response.statusText){
							this.isSending=false
							if(response.resCode==1){
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								this.$emit('changeRecord', '')
								this.data = [];
								this.modalObject.hide();
							}else if(response.resCode==0){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==2){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==3){
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						}else{
							this.isSending=false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}else{	
					createCampaign({data:this.data}).then(response => {
						if(!response.statusText){
							this.isSending=false
							if(response.resCode==1){
								this.toast.success(this.$t('msgCore.dataWasSaved'));
								this.$emit('changeRecord', '')
								this.data = [];
								this.modalObject.hide();
							}else if(response.resCode==0){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==2){
								this.toast.warning(this.$t('msgCore.dataCantBeSaved'));
							}else if(response.resCode==3){
								this.toast.error(this.$t('msgCore.accessDenied'));
							}
						}else{
							this.isSending=false
							this.toast.error(`${response.statusText} ${response.status}`);
						}
					});
				}	
			}
			
		},

		onClose:function(){
			if(this.campaignId!='null'){
				
				unlockCampaign(this.campaignId).then(response => {
					if(!response.statusText){
						console.log(response)
						this.isLoading=false
						if(response.resCode==1){
							this.$emit('changeRecord', '')
							this.modalObject.hide();
						}
					}else{
						this.isLoading=false
						this.toast.error(`${response.statusText} ${response.status}`);
					}
				});
			}else{
				this.$emit('changeRecord', '')
				this.modalObject.hide();
			}
		},

		handleChangeEditor(e) {
			this.data.full_text=e;
			//e.contentWasChanged=true;
		},

	},
	
	watch: {
		campaignId() {
			this.loadDefaultValues();
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
		<div class="modal fade" :id="modalId" tabindex="-1" >
			<div class="modal-dialog modal-xl">
				<LoadingScreen :isLoading="isLoading"></LoadingScreen>
				<div class="modal-content">
					<div class="modal-header">
						<h6 class="modal-title">{{ $t('msgCustomMailing.Campaign') }} <span v-if="!data.isNewRecord"><b>{{ data.title }}</b> id: {{data.id}}</span></h6>
					</div>
			
							<div v-if="metaData.modulAccess && (auth.campaignsNew || auth.campaignsEdit)" class="modal-body">
								
								<div class="row">
									<div class="col-12">
										<div v-if="data.isCheckedOut && secData.userId != data.isCheckedOutId" class="angle">
											<span class="angle-inner" :class="{'angle-warning':data.isCheckedOut}"><i class="fa" :class="{'angle-warning':data.isCheckedOut, 'fa-exclamation-triangle':data.isCheckedOut}" aria-hidden="true"></i> {{$t('msgCore.Edited')}} </span >
											
											<Popper v-if="data.isCheckedOut" :content="data.isCheckedOutName+', '+data.isCheckedOutDate">
												<button class="personCircle v-center" v-bind:style="{background:data.isCheckedOutColor}">{{ data.isCheckedOutLetterName+''+data.isCheckedOutLetterSurname }}</button>
											</Popper>
											
										</div>
									</div>
								</div>
							
								<div class="row">
									
									<div class="col-md-8 col-12">
								
										<ul class="nav nav-tabs" role="tablist">
							
											<li class="nav-item" role="presentation">
												<a class="nav-link active" :id="`${tab1}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab1}`" role="tab" :aria-controls="tab1" aria-selected="true">{{ $t('msgCore.basicData') }}</a>
											</li>
											
											<li v-if="data.typeId==1" class="nav-item" role="presentation">
												<a class="nav-link" :id="`${tab2}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab2}`" role="tab" :aria-controls="tab2" aria-selected="false">Email text</a>
											</li>

											<li v-if="data.typeId==1" class="nav-item">
												<a class="nav-link" :id="`${tab3}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab3}`" role="tab" :aria-controls="tab3" aria-selected="false">Email náhľad</a>
											</li>
											
											<li v-if="data.typeId==2" class="nav-item">
												<a class="nav-link" :id="`${tab4}-tab`" data-bs-toggle="tab" :data-bs-target="`#${tab4}`" role="tab" :aria-controls="tab4" aria-selected="false">SMS text</a>
											</li>

																						
										</ul>

										<div class="tab-content" id="myTabContent">
								
											<div :id="`${tab1}`" class="tab-pane active" role="tabpanel" :aria-labelledby="`${tab1}-tab`">
															
									
												<div class="form-row">
													
																									
													<div class="form-group col-md-4 col-12">
														<label :class="{'text-danger':data.nameError}"><b>{{ $t('msgCore.Title') }}</b> </label>
														<input type="text" class="form-control form-control-sm" :class="{'is-invalid':data.nameError}" v-on:change="checkSave()" v-model="data.name" >
														<div v-show="data.nameError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.fillIn')}}</span></div>
													</div>
													
													<div class="form-group col-md-4 col-12">
														<label :class="{'text-danger':data.typeError}"><b>{{ $t('msgCore.Type') }}</b> </label>								
														<select :disabled="!isNewRecord"  v-model='data.typeId' class="form-control form-control-sm" :class="{'is-invalid':data.typeError}" v-on:change="checkSave()">
															<option  value="">{{ $t('msgCore.selectType') }}</option>
															<option v-for="(options) in optionsTypes" :value="options.value" :key="options.value" >{{ options.title }}</option>
														</select>
														<div v-show="data.typeError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.fillIn')}}</span></div>
													</div>

													<div v-if="data.typeId==1" class="form-group col-md-4 col-12">
														<label :class="{'text-danger':data.templateError}"><b>{{ $t('msgCustomMailing.Template') }}</b> </label>								
														<select v-model='data.templateId' class="form-control form-control-sm" :class="{'is-invalid':data.templateError}" v-on:change="checkSave();onLoadTemplateData();">
															<option  value="">{{ $t('msgCustomMailing.selectTemplate') }}</option>
															<option v-for="(options) in optionsTemplates" :value="options.value" :key="options.value" >{{ options.title }}</option>
														</select>
														<div v-show="data.templateError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.fillIn')}}</span></div>
													</div>
													
												</div>	
											</div>
											
											
											<div v-if="data.typeId==1" :id="`${tab2}`" class="tab-pane" role="tabpanel" :aria-labelledby="`${tab2}-tab`">
												<div class="form-group">
													<label ><b>{{ $t('msgCustomMailing.Subject') }}</b> </label>
													<input type="text" class="form-control form-control-sm" v-on:change="checkSave()" v-model="data.subject" >
													
												</div>

												<div class="form-group">
													<label ><b>{{ $t('msgCustomMailing.BodyMessage') }}</b> </label>
													<tinyMCEeditor :content="data.full_text"  @changeContent="handleChangeEditor" />
												</div>
											</div>

											
											<div v-if="data.typeId==1" :id="`${tab3}`" class="tab-pane" role="tabpanel" :aria-labelledby="`${tab3}-tab`">
												<div class="row">
													<div class="col-12" v-html="template.logo"></div>
												</div>
												<div class="row">
													<div class="col-12">
														<table>
															<tr>
																<td v-html="data.full_text">

																</td>
															</tr>
														</table>
													</div>
												</div>
												<div class="row">
													<div class="col-12" v-html="template.pata"></div>
												</div>
											</div>

											
											<div v-if="data.typeId==2" :id="`${tab4}`" class="tab-pane" role="tabpanel" :aria-labelledby="`${tab4}-tab`">
												<div class="form-group">
													<label ><b>SMS</b> ({{data.sms_text.length}})</label>
													<textarea class="form-control form-control-sm" v-model="data.sms_text" ></textarea>
													
												</div>
											</div>
											
											
												
										</div>
										
									</div>
									
									<div class="col-md-4 col-12 form-control-system-data">
											
										<div class="form-row">
										
											<div class="form-group col-12">
												<label :class="{'text-danger':data.accessError}"><b>{{ $t('msgCore.AccessLevel') }}</b></label>
																									
												<select v-model='data.access' class="form-control form-control-sm " :class="{'is-invalid':data.accessError}" v-on:change="checkSave()">
													<option value="">{{ $t('msgCore.selectLevel') }}</option>
													<option v-for="(option) in optionsAccessLevels" :value="option.value" :key="option">{{ option.title }}</option>
												</select>
												<div v-show="data.accessError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.selectLevel')}}</span></div>
											</div>
											
											<div class="form-group col-12">
												<label :class="{'text-danger':data.stateError}"><b>{{ $t('msgCore.State') }}</b></label>
												
												<div  v-for="(option) in optionsStates" :key="option.value" class="form-check">
													<label class="form-check-label">
														<input class="form-check-input" type="radio" name="optionsStates"  v-model='data.state' v-on:change="checkSave()" :value="option.value">
														{{ $t('msgCore.'+option.title) }}
														<span class="circle">
															<span class="check"></span>
														</span>
													</label>
												</div>
												<div v-show="data.stateError" class="error-input"><span class="badge badge-pill badge-danger">{{$t('msgCore.selectState')}}</span></div>
											</div>
											
											
										
										</div>
										
									</div>										
																		
								</div>
								
							</div>
							
							<div v-else class="modal-body">
								<div class="row">
									<div class="col-12">
										<div class="alert alert-warning" role="alert">
											{{$t('msgCore.accessDenied')}}
										</div>
									</div>
								</div>
							</div>
							
							<div class="modal-footer">
							
								<div class="btn-group">
									<button type="button" v-on:click="onClose()" class="btn btn-default btn-sm">{{ $t('msgCore.btnClose') }}</button>
									
									
									<LoadingButton :isDisabled="(!auth.campaignsEdit || isSending || !metaData.modulAccess)" :isSending="isSending" @onClick="onSave" :label="'msgCore.btnSave'" color="warning"></LoadingButton>
								</div>	
								
							</div>
						
				
					
					
				
				</div>

			</div>
			
		</div>
		
	</div>
	
	

</template>


